import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CubeIcon = function CubeIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CubeIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7.08 1.262a1.76 1.76 0 0 1 1.84 0h.002l4.18 2.547c.277.17.504.414.66.702.156.289.238.613.238.942v5.093c0 .329-.082.654-.238.943a1.87 1.87 0 0 1-.66.702l-.003.002-4.177 2.544-.001.001c-.278.17-.596.262-.921.262s-.643-.091-.92-.262h-.002l-4.177-2.545-.002-.002a1.87 1.87 0 0 1-.661-.702A2 2 0 0 1 2 10.547V5.454c0-.329.082-.654.238-.943s.383-.531.66-.702l.003-.002 4.177-2.544zm1.547 12.17 3.824-2.329h.001a.6.6 0 0 0 .212-.228.7.7 0 0 0 .082-.33V6.097l-4.12 2.28zM8 7.276l4.377-2.423-4.105-2.5a.52.52 0 0 0-.544 0h-.002l-4.103 2.5zM3.254 6.097v4.449c0 .117.03.23.082.329a.6.6 0 0 0 .213.228l3.824 2.33V8.378z",
      clipRule: "evenodd"
    })
  }));
};

export { CubeIcon };
